export const getSendLinkCopy = (sendLinkCommTypeOverride?: string) => {
    if (sendLinkCommTypeOverride === "SMS") {
        return "If that sounds like something you’re interested in, can I text you the link to review the plan and subscribe?";
    }
    return "Can I text you a link to review important plan information and complete your enrollment?";
};
